import dataUtilities from './DataUtilities';
import jsonUtilities from './JsonUtilities';
import { IUtilities } from './IUtilities';
import { IDataUtilities } from './IDataUtilities';
import { IJsonUtilities } from './IJsonUtilities';

class Utilities implements IUtilities {
    constructor() {
        this.data = dataUtilities;
        this.json = jsonUtilities;
    }

    data: IDataUtilities
    json: IJsonUtilities
}


var utilities = new Utilities();
export default utilities as IUtilities;